import { StatusCircleProps } from '@src/components/StatusCircle/StatusCircle';
import { colors } from '@src/styles';

export const getDefinitionStatus = (
  definitionId: string,
  publishedAt?: string,
  currentPublishedDefinitionId?: string,
): StatusCircleProps['data'] => {
  if (!publishedAt) return { color: colors.background.secondary, message: 'Rascunho' };
  if (currentPublishedDefinitionId !== definitionId)
    return { color: colors.primary.yellow, message: `Anteriormente publicado - ${publishedAt}` };
  return {
    color: colors.primary.green,
    message: `Publicado atual - ${publishedAt}`,
  };
};
